// @flow
import moment from 'moment'
import queryStringToObject from 'mz-utils/queryStringToObject'
import allowedQueries from '../../constants/allowedQueries'

const DATE_FORMAT = 'MM/DD/YYYY hh:mm a'

/**
 * Returns an object from an URL query
 * @param  {string} value URL to parse
 * @return {Object}     Parsed Object
 */
export const parse = (value: Object | string): Object => {
  let query: any = value

  if (typeof value === 'string' || value instanceof String) {
    query = queryStringToObject(value)
  }

  return Object.keys(query).reduce((result: Object, key: any): Object => {
    if (!(key in allowedQueries) || !query[key]) {
      return result
    }

    const queryParamValue = query[key]

    // if param is Array just take the last value
    // for others parse as expected type
    const paramValue = Array.isArray(queryParamValue)
      ? queryParamValue[queryParamValue.length - 1]
      : queryParamValue

    const parsed = allowedQueries[key](paramValue)
    const addition = {}

    switch (key) {
      case 'pickup_datetime':
        addition[key] = moment(parsed, DATE_FORMAT)
        break
      case 'return_pickup_datetime':
        addition[key] = moment(parsed, DATE_FORMAT)
        break
      case 'flight_datetime':
        addition[key] = moment(parsed, DATE_FORMAT)
        break
      case 'return_flight_datetime':
        addition[key] = moment(parsed, DATE_FORMAT)
        break
      default:
        addition[key] = parsed
    }

    return {
      ...result,
      ...addition,
    }
  }, {})
}

export default parse
